// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__agz4q","topBottomGutter":"Layout_topBottomGutter__1omFu"};